import React, { useContext, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import { SECTIONS } from "../../../assets/MockData/mockData";
import { ReactComponent as COLLAPSE_IMG } from "../../../assets/images/Frame (34).svg";
import MyPopover from "../../Common/Popover/MyPopover";

const SideBarClosed = ({ toggleSideBar }) => {
  const [sections] = useState(SECTIONS);
  const { updateSelectedOption } = useContext(AppContext);

  return (
    <div className="closed-sidebar-content">
      <MyPopover
        icon={<COLLAPSE_IMG style={{ width: "25px", height: "25px" }} />}
        position="left"
        title="메뉴 열기"
        onClick={() => toggleSideBar(true)}
      />

      {sections.map((section) =>
        section.options.map((option, optionIndex) => (
          <MyPopover
            key={`${section.name}-${option.text}-${optionIndex}`}
            parentOption={option}
            subOptions={option?.dropdownOptions}
            position="left"
            onClick={() => updateSelectedOption(option.sidebarUrl)}
          />
        ))
      )}
    </div>
  );
};

export default SideBarClosed;
